export default __webpack_public_path__ + "static/media/ThePowerpuffGirls_04.58d350ca.png";